




































































import {Component, Mixins} from 'vue-property-decorator';
import {
  CaseIdfSelectDialogRequest,
  IdfListInfo, IdfRetrieveResponse,
} from '@/model/CommonModel';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DefaultPaginateMixin from '@/views/DefaultPaginateMixin';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import TextInput from '@/components/input/TextInput.vue';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import IconButton from '@/components/button/IconButton.vue';
import CommonApi from '@/api/CommonApi';
import DataTable from '@/components/table/DataTable.vue';

@Component({
  components: {TextInput, CommonPromptDialog, CommonButton, IconButton, DataTable},
  mixins: [DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin]
})
export default class CaseIdfSelectDialog extends Mixins(DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin) {
  private values: IdfListInfo[] = [];
  private errMsg: string = '';
  private title: string = '';
  private isSubstance: boolean;
  private idfVersion: string = '';

  private onSelect: (row: IdfListInfo) => void;
  private onCancel: (keyword: string) => void;

  get getAlert() {
    return this.errMsg;
  }

  get getTitle() {
    return this.title;
  }

  get getValues() {
    return this.values;
  }

  get isLoading() {
    return this.loading;
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showCaseIdfSelectDialog', (params: CaseIdfSelectDialogRequest) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideIdfSelectDialog', () => this.close());
  }

  public show(request: CaseIdfSelectDialogRequest) {
    this.errMsg = this.$t('message.case.dialog.alert').toString();
    this.title = request.idfVersionInfo.version;
    this.idfVersion = request.idfVersionInfo.versionCode;
    this.width = request.width ? request.width : this.DEFAULT_WIDTH;
    this.onSelect = request.onSelect;
    this.onCancel = request.onCancel;
    this.keyword = request.keyword;
    this.maxLength = request.maxLength;
    this.isSubstance = request.isSubstance;
    this.loading = false;
    this.visible = true;
    this.retrieve(1, 10);
  }

  public retrieve(pageNo: number, rowCount: number) {
    this.lastKeyword = this.keyword;
    this.keyword = this.keyword.trim();

    if (!this.keyword) {
      this.values = [];
      return;
    }

    if (this.keyword?.length < 2) {
      this.errMsg = this.$t('message.case.dialog.directInputMinLength').toString();
      this.values = [];
      return;
    }

    if (this.isKeywordMaxlengthExceed) {
      this.errMsg = this.$t('message.case.dialog.directInputMaxlengthExceed').toString();
      return;
    }

    this.errMsg = this.$t('message.case.dialog.alert').toString();

    const params = {searchText: this.keyword, idfVersion: this.idfVersion};
    this.loading = true;
    return CommonApi.retrieveIdfCodes(params)
        .then((res: IdfRetrieveResponse) => {
          if (!res.success) {
            return Promise.reject(res.errMsg);
          }

          this.values = res.data;
        })
        .catch((errMsg) => this.afterRequestFail(errMsg))
        .finally(() => this.loading = false);
  }

  public onInput() {
    if (this.isKeywordMaxlengthExceed) {
      this.errMsg = this.$t('message.case.dialog.directInputMaxlengthExceed').toString();
      return;
    }

    this.onRowClick({
        drugCode: this.keyword
    });
  }

  public onRowSearchClick(data: any) {
    if (this.isSubstance) {
      data.drugCode = data.drugCode.substring(0, 7);
    }

    this.onRowClick(data);
  }

  public onRowClick(data: any) {
    if (this.onSelect) {
      this.onSelect(data);
    }

    this.close();
  }

  public close() {
    if (this.onCancel) {
      this.onCancel(this.lastKeyword);
    }
    this.visible = false;
  }

  public afterClosed() {
    this.values = [];
    this.keyword = '';
    this.lastKeyword = '';
    this.loading = false;
  }

  public destroyed() {
    this.$modal.getEventBus().$off('caseIdfSelectDialog');
    this.$modal.getEventBus().$off('hideCaseIdfSelectDialog');
  }
}
